exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert[data-v-74b6b54d] {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n", ""]);

// exports
